<template>
  <!-- item -->
  <div class="schema-form__item" :class="{ normal: item.layoutType === 'normal', [item.as]: true }">
    <!-- label -->
    <div v-if="item.label" class="schema-form__label" :style="labelStyle">
      {{ item.label }}
      <span class="schema-form__sublabel">{{ item.subLabel }}</span>
      <a-tooltip v-if="item.desc">
        <template #title>{{ item.desc }}</template>
        <QuestionCircleOutlined class="text-3.5 mr-1" />
      </a-tooltip>
      <a-tooltip :title="t('common.copy')" placement="top" v-if="item.copyable">
        <copy-outlined @click="copyText(values[item.name])" style="font-size: 13px" />
      </a-tooltip>
    </div>
    <!-- component -->
    <Field v-slot="{ field, handleChange, handleInput }" validate-on-input :name="item.name || ''">
      <component
        v-bind="{
          values,
          field,
          config: item,
          disabled,
          handleChange,
          handleInput,
        }"
        :is="`schema-form__${item.as}`"
        class="schema-form__component"
        :global-data="globalData"
        :style="item.compStyle || {}"
        @component-event="value => handleCompEvent(value, item)"
      />
      <!-- <pre>{{ field.value }}</pre> -->
    </Field>
    <div class="guide">
      <a-popover trigger="hover" v-if="item.guide" :placement="item.guide?.placement || 'bottom'">
        <template #content>
          <a :href="item.guide.img" target="_blank"><img :src="item.guide.img" alt="" :width="item.guide.width" /></a>
        </template>
        <QuestionCircleOutlined class="text-3.5 ml-2" />
      </a-popover>
    </div>
    <!-- 字段描述 -->
    <div v-if="item.descriptions?.length" class="full-w mt1">
      <div v-for="desc in item.descriptions" :key="desc" class="gray9 fs12">
        {{ desc }}
      </div>
    </div>
    <div flex-box="1" class="error full-w" :style="{ paddingLeft: schema.blockLabel ? '0' : labelStyle.width }">
      <ErrorMessage v-slot="{ message }" :name="item.name">
        {{ message }}
      </ErrorMessage>
    </div>
  </div>
</template>
<script>
import { Field, ErrorMessage } from 'vee-validate';
import { computed, inject, defineComponent } from 'vue';
import { get } from 'lodash-es';
import { QuestionCircleOutlined, CopyOutlined } from '@ant-design/icons-vue';
import { copyText } from '@/utils';
import i18n from '@/locales/i18n';

export default defineComponent({
  name: 'SchemaFormItem',
  components: { Field, ErrorMessage, QuestionCircleOutlined, CopyOutlined },
  props: {
    schema: { type: Object, default: () => ({}) },
    parent: { type: Object, default: () => ({}) },
    item: { type: Object, default: () => ({}) },
    values: { type: Object, default: () => ({}) },
  },
  emits: ['component-event'],
  setup(props, { emit }) {
    const { t } = i18n.global;

    const globalData = inject('globalData');
    const disabled = computed(() => {
      const type = props.item.disabledType || 'and';
      // boolean类型直接返回
      if (props.item.disabled === undefined || typeof props.item.disabled === 'boolean') {
        return !!props.item.disabled;
      }
      const arr = Object.keys(props.item.disabled || {});

      let result = true;
      if (type === 'and') {
        const hasFalse = arr.some(i => {
          const value = props.item.disabled[i];
          // 例子：Id: '>0'
          // TODO：这里需要处理xss，比如'>0,alert(1)'
          // ↑为了解决上述问题，这里限制value的格式大于或小于一个数字（支持小数）' > 10.12121 '
          const reg = /^\s*[<>]\s*(0|[1-9]\d*)(\.\d+)?\s*$/;
          if (typeof value === 'string' && reg.test(value)) {
            const exp = `return ${get(props.values, i)}${value}`;
            // console.log(exp)
            return !new Function(exp)();
          } else {
            return get(props.values, i) !== value;
          }
        });
        result = !hasFalse;
      } else if (type === 'or') {
        result = arr.some(i => get(props.values, i) === props.item.disabled[i]);
      }
      return result;
    });

    // console.log(props.item.label, props.item.name, props.parent);
    const labelStyle = {
      width:
        props.item.labelWidth ||
        props.parent.labelWidth ||
        props.schema.labelWidth ||
        (props.schema.blockLabel || props.item.blockLabel ? '100%' : ''),
      ...(props.schema.labelStyle || {}),
      ...(props.parent.labelStyle || {}),
      ...(props.item.labelStyle || {}),
    };

    const handleCompEvent = (value, from) => {
      emit('component-event', { ...value, $from: from });
    };

    return {
      copyText,
      globalData,
      disabled,
      labelStyle,
      handleCompEvent,
      t,
    };
  },
});
</script>
<style lang="less" scoped>
.schema-form__item {
  display: block;
  flex-wrap: wrap;
  margin: 8px 0;
  padding: 0 2px;
  &:not(.normal) {
    display: flex;
    align-items: center;
  }
}
.error {
  margin: 0 0 0 5px;
  font-size: 12px;
  color: red;
}
.schema-form__sublabel {
  font-size: 12px;
}
.schema-form__label {
  flex-grow: 0;
  flex-shrink: 0;
  font-weight: 500;
  margin: 3px 5px 3px 0;
}
</style>
